export default "<map-location>\n    <div class=\"map-attach container container--sm\" id=\"map-attach\"></div>\n</map-location>";